module.exports = __webpack_public_path__ + "static/media/M mall shot 02.png2-mobile.274681ea.webp";